import { useI18n } from "../context/I18nContext";

export default function Marquee() {
  const { t } = useI18n();
  const words = t.marquee.words;

  return (
    <div
      data-testid="editorial-marquee"
      className="marquee overflow-hidden border-y border-white/10 bg-ember py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {words.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-corm text-3xl italic text-terra/90 md:text-4xl">
                {w}
                <span className="mx-8 inline-block h-1.5 w-1.5 rounded-full bg-cream/25 md:mx-12" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
